import hljs from 'highlight.js';

onmessage = (event) => {
    let result;
    if(hljs.getLanguage(event.data.language)){
        result = hljs.highlight(event.data.language, event.data.element);
    }else{
        result = hljs.highlightAuto(event.data.element);
    }

    postMessage({
        id: event.data.id,
        result: result.value,
        language: result.language
    });
};
